import { createSlice } from '@reduxjs/toolkit';
import {
  openAppInModal,
  modalAppLoaded,
  appError,
  closeModal,
} from '../actions';

export interface CurrentModalAppState {
  name: string | null;
  instance: { destroy?: () => void } | null;
  loading: boolean;
  visible: boolean;
}

export const initialModalAppState: CurrentModalAppState = {
  name: null,
  instance: null,
  loading: false,
  visible: false,
};

// TODO: side-effecting helper called inside a reducer (calls instance.destroy()).
// This is an anti-pattern — the destroy side effect should move to middleware /
// the dispatching component. Kept as-is during the RTK migration; refactor later.
const eventuallyDestroyModalApp = ({
  instance,
}: CurrentModalAppState): CurrentModalAppState => {
  if (instance && instance.destroy) {
    instance.destroy();
  }
  return initialModalAppState;
};

const currentModalAppSlice = createSlice({
  name: 'currentModalApp',
  initialState: initialModalAppState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(openAppInModal, (state, action) => {
        if (!action.payload.name) {
          return eventuallyDestroyModalApp(state);
        }
        eventuallyDestroyModalApp(state);
        return {
          ...action.payload,
          loading: true,
          instance: null,
          visible: false,
        };
      })
      .addCase(modalAppLoaded, (state, action) => {
        const instance = action.payload;
        state.instance = instance;
        state.loading = false;
        state.visible = !!instance;
      })
      .addCase(appError, eventuallyDestroyModalApp)
      .addCase(closeModal, eventuallyDestroyModalApp);
  },
});

export const currentModalAppReducer = currentModalAppSlice.reducer;
